import { render, staticRenderFns } from "./c-amap.vue?vue&type=template&id=c24c0376&scoped=true&"
import script from "./c-amap.vue?vue&type=script&lang=js&"
export * from "./c-amap.vue?vue&type=script&lang=js&"
import style0 from "./c-amap.vue?vue&type=style&index=0&id=c24c0376&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c0376",
  null
  
)

export default component.exports